import { Avatar as MuiAvatar, AvatarProps } from '@mui/material';
import { FC } from 'react';
import { useThemeMode } from '../themes/themeModeProvider';
import { ThemeMode } from '../types/config';

export const Avatar: FC<AvatarProps> = (props: AvatarProps) => {
	const { mode } = useThemeMode();

	return <MuiAvatar {...props} src={props.src ?? (mode === ThemeMode.LIGHT ? '/avatar-light.jpg' : '/avatar-dark.jpg')} />;
};
